export const monthYearLabel = {
    monthLabel: 'FINANCING_STEPS.MONTH',
    yearLabel: 'FINANCING_STEPS.YEAR',
};

export const tenureOptionsMonths = Array.from({ length: 11 }, (_, index) => ({
    value: (index + 1).toString(),
    label: `FINANCING_STEPS.TENURE_OPTIONS.MONTHS.${index}`,
}));

export const tenureOptionsYears = Array.from({ length: 10 }, (_, index) => ({
    value: (index + 1).toString(),
    label: `FINANCING_STEPS.TENURE_OPTIONS.YEARS.${index}`,
}));
